// This page handles the impersonate redirect
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import useAuthStore from '../../store/authStore';

export default function Impersonate() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setUser, setToken } = useAuthStore();

  useEffect(() => {
    const doImpersonate = async () => {
      try {
        const r = await api.post(`/superadmin/clients/${id}/impersonate`);
        // Store admin token for return
        const adminToken = localStorage.getItem('token');
        localStorage.setItem('adminToken', adminToken);
        localStorage.setItem('adminReturnUrl', '/admin/clients');
        // Set impersonation token
        localStorage.setItem('token', r.data.token);
        localStorage.setItem('isImpersonating', 'true');
        setToken(r.data.token);
        setUser(r.data.user);
        navigate('/client/dashboard');
      } catch (e) {
        alert('Impersonation failed: ' + (e.response?.data?.message || e.message));
        navigate('/admin/clients');
      }
    };
    doImpersonate();
  }, [id]);

  return (
    <div style={{ minHeight:'100vh', background:'#0A0A0A', display:'flex', alignItems:'center', justifyContent:'center', color:'#2ECC71', fontSize:16 }}>
      ⏳ Switching to client view...
    </div>
  );
}
